import { IBroker } from "../modals/Broker.modal";
import { IResponse } from "../modals/response.modal";
import ApiService from "./api.service";
import axiosAuth from "./axios-interceptor";


class KCService {

    createBroker(formData: any) {
        return axiosAuth.post(`${ApiService.Broker}/saveBroker`, formData);
    }

    getAllBrokers() {
        return axiosAuth.get<IResponse<IBroker[]>>(`${ApiService.Broker}/getBrokers`);
    }
    
}

export default new KCService();
